import { DispatchViewModel } from '@/app/models/dispatch.model';
import { DispatchWidget } from '@/app/models/widget.model';
import { DispatchService } from '@/app/services/dispatch.service';
import { ExternalUrlsService } from '@/app/services/external-urls.service';
import { EmptyStateComponent } from '@/app/shared/components/empty-state/empty-state.component';
import { environment } from '@/environments/environment';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-shared-services';
import { WidgetHeaderComponent } from '../../../shared/components/widget-header/widget-header.component';
import { TimezoneDatePipe } from '@/app/pipes/timezone-date.pipe';
import { MixPanelEvent } from '@/app/services/mixpanel.service';

@Component({
  selector: 'dr-flex-home-ui-dispatch-widget',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslateModule, RouterModule, WidgetHeaderComponent, EmptyStateComponent, TimezoneDatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dispatch-widget.component.html',
  styleUrl: './dispatch-widget.component.scss',
})
export class DispatchWidgetComponent implements OnInit {
  widget = input.required<DispatchWidget>();
  private readonly dispatchService = inject(DispatchService);
  readonly dispatches = toSignal<DispatchViewModel[] | null>(this.dispatchService.getDispatchesRows({ limit: 4 }), { initialValue: null });
  readonly activeEventsUrl = inject(ExternalUrlsService).activeEvents;
  private readonly cookieService = inject(CookieService);
  readonly locale = signal('');
  readonly mixPanelEvent = MixPanelEvent;

  ngOnInit(): void {
    this.locale.set(this.cookieService.getI18NLocale() || environment.defaults.locale);
  }
}
